module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 023.2840c00c.jpg";